export default {
  GET_SAVED_SEARCHES: 'GET_SAVED_SEARCHES',
  GET_STUDY_SUMMARIES: 'GET_STUDY_SUMMARIES',
  GET_ANALYTICS: 'GET_ANALYTICS',
  GET_CONCEPTS: 'GET_CONCEPTS',
  GET_ANALYTICS_ATTRIBUTES: 'GET_ANALYTICS_ATTRIBUTES',
  GET_ANALYTICS_TENDENCIES: 'GET_ANALYTICS_TENDENCIES',
  GET_CICS_QUESTIONS: 'GET_CICS_QUESTIONS',
  GET_CICS_FILTERS: 'GET_CICS_FILTERS',
  GET_ANALYTICS_PROFILE: 'GET_ANALYTICS_PROFILE',
  GET_QUESTIONS: 'GET_QUESTIONS',
  GET_FRAGRANCES: 'GET_FRAGRANCES',
  GET_QUESTIONNAIRES: 'GET_QUESTIONNAIRES',
  GET_SCREENERS: 'GET_SCREENERS',
  GET_FIELDS: 'GET_FIELDS',
  GET_REPORTS: 'GET_REPORTS',
  GET_METRICS_JOB_ID: 'GET_METRICS_JOB_ID',
  GET_PERFORMANCE_JOB_ID: 'GET_PERFORMANCE_JOB_ID',
  GET_ATTRIBUTES_JOB_ID: 'GET_ATTRIBUTES_JOB_ID',
  GET_TENDENCIES_JOB_ID: 'GET_TENDENCIES_JOB_ID',
  GET_METRICS_XLSX_JOB_ID: 'GET_METRICS_XLSX_JOB_ID',
  GET_METRICS_ANALYTIC_JOB_ID: 'GET_METRICS_ANALYTIC_JOB_ID',
  GET_PERFORMANCE_XLSX_JOB_ID: 'GET_PERFORMANCE_XLSX_JOB_ID',
  GET_ATTRIBUTES_XLSX_JOB_ID: 'GET_ATTRIBUTES_XLSX_JOB_ID',
  GET_TENDENCIES_XLSX_JOB_ID: 'GET_TENDENCIES_XLSX_JOB_ID',
  GET_PROTOCOLS: 'GET_PROTOCOLS',
  GET_RESULTS: 'GET_RESULTS',
  GET_SEARCH_FILTERS: 'GET_SEARCH_FILTERS',
  GET_STUDY_DETAILS_METADATA: 'GET_STUDY_DETAILS_METADATA',
  GET_STUDY_ERROR: 'GET_STUDY_ERROR',
  GET_STUDY_DETAILS_TAGS: 'GET_STUDY_DETAILS_TAGS',
  GET_CONCEPTS_TAGS: 'GET_CONCEPTS_TAGS',
  GET_FRAGRANCES_TAGS: 'GET_FRAGRANCES_TAGS',
  GET_STUDY_DETAILS_FRAGRANCE_DETAILS: 'GET_STUDY_DETAILS_FRAGRANCE_DETAILS',
  GET_STUDY_DETAILS_CONCEPTS: 'GET_STUDY_DETAILS_CONCEPTS',
  GET_STUDY_COUNT: 'GET_STUDY_COUNT',
  GET_SIGNIFICANCE_RESULTS: 'GET_SIGNIFICANCE_RESULTS',
  GET_SIGNIFICANCE_JOB_ID: 'GET_SIGNIFICANCE_JOB_ID'
}
